'use client'

import { Button } from '@/core/components/form/button/button'
import { useViewer } from '@/features/viewer/hooks/use-viewer'

import { clearVehicle } from '../actions/vehicle'

import type { ReactNode } from 'react'

type ClearVehicleButtonProps = {
  onlyForVehicleId?: string
  className?: string
  children: ReactNode
}

export default function ClearVehicleButton({
  onlyForVehicleId,
  className,
  children,
}: ClearVehicleButtonProps) {
  const { viewer, patch } = useViewer()
  if (onlyForVehicleId && viewer?.vehicle?.id !== onlyForVehicleId) return null

  return (
    <form
      action={async () => {
        await clearVehicle()
        await patch({ vehicle: null })
      }}
      className="inline"
    >
      <Button type="submit" variant="ghost" size="sm" className={className}>
        {children}
      </Button>
    </form>
  )
}
